import { render, staticRenderFns } from "./purchase_and_shipping.vue?vue&type=template&id=1a004378&scoped=true&"
import script from "./purchase_and_shipping.vue?vue&type=script&lang=js&"
export * from "./purchase_and_shipping.vue?vue&type=script&lang=js&"
import style0 from "./purchase_and_shipping.vue?vue&type=style&index=0&id=1a004378&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a004378",
  null
  
)

export default component.exports